import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";

const Time = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    value: "00:00:00",
    title: props.title, //"Normal UI"
    disabled: false, //if returned value == na set to false
    progress: false,
    acc: props.acc,
  });
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title;

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        //console.log(convertTime12To24(message.value.toString()));
        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: true,
            progress: false,
          });
        } else {
          setState({
            ...state,
            value:
              message.value == undefined ? 0 : convertTime12To24(message.value),
            disabled: false,
            progress: false,
          });
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter(val) {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(val);
    } else {
      setTimeout(function () {
        requestdata(val);
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata(val) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: val.toString(),
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  function convertTime12To24(time) {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM.toString().toLowerCase() === "pm" && hours < 12)
      hours = hours + 12;
    if (AMPM.toString().toLowerCase() === "am" && hours === 12)
      hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes + ":00";
  }

  function convertTime24To12(time24) {
    var ts = time24;
    var H = +ts.substr(0, 2);
    var h = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " am" : " pm";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }

  //className="form-check-input" className="form-check-label"
  return (
    <div
      className="grid-item"
      style={{ display: state.disabled ? "none" : "block" }}
    >
      <div
        className="form-check form-switch"
        style={{ display: state.progress ? "none" : "block" }}
      >
        <label
          htmlFor={props.category + "_" + props.subcategory + "_" + props.title}
        >
          <strong>{state.title}</strong>
        </label>
        &nbsp;
        <input
          type="time"
          className="timepicker"
          onChange={(e) => {
            console.log("time picker value_" + e);
            setState({
              ...state,
              value: e.target.value,
            });
          }}
          onBlur={(e) => {
            setparameter(convertTime24To12(state.value));
            setState({
              ...state,
              progress: true,
            });
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              setparameter(convertTime24To12(state.value));
              setState({
                ...state,
                progress: true,
              });
            }
          }}
          id={props.category + "_" + props.subcategory + "_" + props.title}
          value={state.value}
          disabled={!state.acc}
        />
      </div>
      <div
        className="spinner-border text-primary"
        style={{ display: state.progress ? "block" : "none" }}
      ></div>
    </div>
  );
};
/*        <TimePicker           amPmAriaLabel="Select AM/PM"
          clearIcon={null}
          format="hh:mm a"/> */
export default Time;
